export const settingZoneExplain = parentVue => {
    return {
        description: `<p>${parentVue.$i18n.t("ipDomainCerts.pageDescription")}</p>`
    };
};

// 與 CertsManage 共用 rcmtableFieldsV2 的欄位定義，僅覆寫本頁面的表單型態
export const commonName = parentVue => {
    return {
        formTypes: [],
        formRender: "TextOnly"
    };
};

export const validityStart = parentVue => {
    return {
        formTypes: ["editForm"],
        formRender: "TextOnly",
        validate: []
    };
};

export const validityEnd = parentVue => {
    return {
        formTypes: ["editForm"],
        formRender: "TextOnly",
        validate: []
    };
};

export const action = parentVue => {
    return {
        width: 120,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const viewBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: "md-eye"
                },
                on: {
                    click: () => {
                        vm.viewItem(params.row);
                    }
                }
            });

            var dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText")
                }
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                        disabled: vm.isDeleteBtnDisabled
                    },
                    on: {
                        "on-click": value => {
                            var currentItem = dropdownItems.find(e => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                }
                            });
                        }
                    }
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index
                            }
                        })
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list"
                        },
                        [
                            dropdownItems.map(function(item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled
                                        }
                                    },
                                    item.title
                                );
                            })
                        ]
                    )
                ]
            );

            const actionDivArray = [];

            if (vm.userCanIndex) {
                actionDivArray.push(viewBtn);
            }

            if (vm.$store.getters.isAdmin) {
                actionDivArray.push(moreBtn);
            }

            return h("div", actionDivArray);
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/IpDomainCerts/fields.js